import React, { useState } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import request from "../../../utilities/requests";
import { toast } from "../../../utilities/SnackBarUtils";

const NameStep = ({ profile, onComplete }) => {
  const { t } = useTranslation();
  const [firstName, setFirstName] = useState(profile?.firstName || "");
  const [lastName, setLastName] = useState(profile?.lastName || "");
  const [saving, setSaving] = useState(false);

  const canSave = Boolean(firstName.trim() && lastName.trim());

  const handleSave = async () => {
    if (!canSave) return;
    setSaving(true);
    const result = await request("profile/update", "post", {
      firstName: firstName.trim(),
      lastName: lastName.trim(),
    });
    setSaving(false);
    if (!result.success) {
      toast.error(t("setup.name.error"));
      return;
    }
    onComplete({ firstName: firstName.trim(), lastName: lastName.trim() });
  };

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 1 }}>
        {t("setup.name.title")}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {t("setup.name.body")}
      </Typography>

      <TextField
        fullWidth
        label={t("setup.name.first")}
        value={firstName}
        onChange={(e) => setFirstName(e.target.value)}
        autoFocus
        sx={{ mb: 2 }}
      />
      <TextField
        fullWidth
        label={t("setup.name.last")}
        value={lastName}
        onChange={(e) => setLastName(e.target.value)}
        sx={{ mb: 3 }}
      />

      <Button
        className="tnfm-pill-btn"
        variant="contained"
        fullWidth
        disabled={!canSave || saving}
        onClick={handleSave}
      >
        {saving ? t("setup.saving") : t("setup.continue")}
      </Button>
    </Box>
  );
};

export default NameStep;
